module.exports = __webpack_public_path__ + "static/media/piper-rocket.2aad09cc.gif";